import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, ManyToOne, JoinColumn, OneToOne,
} from 'typeorm';
import { IsOptional, IsInt, IsString, IsEmail, IsBoolean } from 'class-validator';
import { Grupo } from './Grupo';
import { Paciente } from './Paciente';

@Entity({name: "usuarios"})
export class Usuario {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsOptional()
  @IsInt()
  paciente_id?: number;

  @Column()
  @IsString()
  nome: string;

  @Column()
  @IsEmail()
  email: string;

  @Column({ select: false })
  @IsString()
  senha: string;

  @Column()
  @IsInt()
  grupo_id: number;

  @Column()
  @IsBoolean()
  ativo: boolean;

  @Column()
  @IsString()
  @IsOptional()
  token_ativacao?: string;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @UpdateDateColumn()
  @IsOptional()
  updated?: Date;

  // RELATIONS
  @OneToOne(type => Paciente, paciente => paciente.usuario)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @ManyToOne(type => Grupo, grupo => grupo.usuarios)
  @JoinColumn({ name: 'grupo_id' })
  grupo?: Grupo;
}
